import {
  ActionActiveRackBase,
  ActionSetActiveAll,
  ActiveRackActionTypes,
} from "./actionTypes";

const DEFAULT_RACK = "XXX";
const DEFAULT_CELL = "XX";

interface IState {
  rack: string;
  cell: string;
  miner?: string;
}

const initialState: IState = {
  rack: DEFAULT_RACK,
  cell: DEFAULT_CELL,
  miner: undefined,
};

const reducer = (
  state = initialState,
  action: ActionActiveRackBase
): IState => {
  switch (action.type) {
    case ActiveRackActionTypes.SET_RACK:
      return {
        ...state,
        rack: action.payload,
      };
    case ActiveRackActionTypes.SET_CELL:
      return {
        ...state,
        cell: action.payload,
      };
    case ActiveRackActionTypes.SET_ACTIVE_ALL:
      const pl = action.payload as ActionSetActiveAll["payload"];
      return {
        ...state,
        cell: pl.cell,
        rack: pl.rack,
        miner: pl.miner,
      };
    case ActiveRackActionTypes.REMOVE_RACK:
      return {
        ...state,
        rack: DEFAULT_RACK,
        cell: DEFAULT_CELL,
      };
    case ActiveRackActionTypes.REMOVE_CELL:
      return {
        ...state,
        cell: DEFAULT_CELL,
      };
    case ActiveRackActionTypes.REMOVE_ALL:
      return {
        ...state,
        cell: DEFAULT_CELL,
        rack: DEFAULT_RACK,
        miner: undefined,
      };
    default:
      return state;
  }
};

export default reducer;
